import { __decorate } from "tslib";
import { css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { sharedStyles } from '../../common/css/shared-styles';
import { USBrandCampaign } from '../../common/us-branding';
//import scrollama from "scrollama";
let CampaignSectionDigitalAssets = class CampaignSectionDigitalAssets extends USBrandCampaign {
    constructor() {
        super(...arguments);
        this.seen = false;
    }
    render() {
        return html `
        <div class="component--full">
          <div class="grid">
            <div class="left-col ${this.seen ? `animate` : ``}">
                <div class="inner">
                    <h2>Digital asset</h2>
                    <!--p>When it comes to digital assets, we’re no new kids on the blockchain. In 2019 we launched the first US registered mutual fund to use public blockchains to process transactions and record share ownership, and have been innovating ever since. With a suite of digital asset offerings and a course to help you <a href="https://www.franklintempleton.com/practice-management/franklin-templeton-academy/discovering-digital-assets">decode digital assets</a>, we’re setting the pace of blockchain innovation in asset management.</p-->
                    <p>Nel mondo dei digital asset, Franklin Templeton è un vero pioniere e un convinto sostenitore dell’innovazione.<br />Siamo attivi sulle blockchain dal 2018, investendo e sviluppando direttamente in questo ecosistema in continua evoluzione. Nel 2021, abbiamo segnato un traguardo storico: il lancio del primo titolo digitale registrato negli Stati Uniti su una blockchain pubblica.<br />Da allora, non abbiamo mai smesso di innovare.<br />Con un’ampia gamma di soluzioni in <em><a href="https://www.franklintempleton.it/approfondimenti/ft-academy#featured-course" target="_blank" @click="${this.trackLink}" data-link-title="digital asset">digital asset</a></em>, risorse educative e corsi formativi, siamo al tuo fianco per aiutarti a comprendere e cogliere le opportunità offerte da questa nuova ed entusiasmante frontiera dei risk asset.</p>
                    <div>
                      <a href="https://www.franklintempleton.it/investi-con-noi/competenze-negli-investimenti/alternativi/categories/digital-assets" class="button" @click="${this.trackLink}" target="_blank">Scopri di più</a>
                    </div>
                </div>
              </div>
            <div class="right-col ${this.seen ? `animate` : ``}">
              <img src="./media/img/BRAND-DA-IMAGE-1224-867x392.jpg" alt="Digital assets delivered" class="banner" />
            </div>
          </div>
        </div>
        <slot></slot>`;
    }
};
CampaignSectionDigitalAssets.styles = [
    sharedStyles,
    css `
    :host {
        display: flex;
        margin: 0 auto;
        background: transparent;
        padding: 0;
        position: relative;
        z-index: 4;
        align-content: center;
        flex-wrap: wrap;                
    }

    @media (orientation: landscape) {
      :host {
        /*min-height: 100vh;*/
      }
    }    

    .left-col {
      width: 100%;  
      margin-bottom: 2rem;
    }
        
    img {
      width: 100%;
      display: none;
    }

    @media(min-width: 768px) {
      .grid {  
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-template-rows: 1fr;
        gap: 5rem;
        grid-auto-flow: row;
        overflow: hidden;
      }

      .left-col {
        justify-self: end; 
        align-self: center;
        grid-area: 1 / 1 / 2 / 2;
        width: 100%;
        transform: translateX(-50px);
        opacity: 0;      
      }

      .right-col {
        justify-self: end;
        align-self: start;
        grid-area: 1 / 2 / 2 / 3;
        width: 100%;
        transform: translateX(50px);
        opacity: 0;      
  
        & img {
          width: 100%;
        }
      }      
      .left-col.animate {
        animation: fade-in-left 2s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
      }
  
      .right-col.animate {
        animation: fade-in-right 2s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
      }
    }

    
    @media(min-width: 1200px) {
      .left-col {
        width: 100%
      }
    }
    

    h2, p, a, a:visited {
      color: #fff;
    }

    a.button {
        display: inline-block;
        background: #ffffff;
        padding: 0.6rem 1.25rem;
        border-radius: 45px;
        text-decoration: none;
        color: var(--ft-sky-blue);
      }        

    .inner {
      width: 100%;
    }   

    .component--full {
      margin: 2rem;
    }

    @media(min-width: 768px) {

      .banner {
        border-radius: 5px 140px 5px 5px;
      }

      .component--full {
        margin: 0rem 2rem;
      }      

      p, a {
        font-size: 1.1rem;
      }      
    }

    @media(min-width: 1200px) {
      .component--full {
        margin: 0rem 3rem 0 0;
        width: 100%;
        padding-left: calc((100vw - 1200px) / 2);
      }        
    }



  `
];
__decorate([
    property({ type: Boolean })
], CampaignSectionDigitalAssets.prototype, "seen", void 0);
CampaignSectionDigitalAssets = __decorate([
    customElement('campaign-section-digital-assets')
], CampaignSectionDigitalAssets);
export { CampaignSectionDigitalAssets };
//# sourceMappingURL=campaign-section-digital-assets.js.map